import moment from 'moment';
import DeleteItemIcon from '../../../media/delete-item.svg';
import EditItemIcon   from '../../../media/edit-item.svg';

export const ViewMasterGroups = ({
                                     data,
                                     editHandler,
                                     deleteHandler,
                                     isLoadingDelete,
                                     useTranslation
                                 }) => {
    const { t } = useTranslation();

    return (
        <div className="table-responsive bg-light p-3 mt-2">
            <table className="table table-sm table-border edit-grid-view">
                <thead className="border-0">
                <tr>
                    <th>{t('Created')}</th>
                    <th>{t('Group Name')}</th>
                    <th>{t('Description')}</th>
                    <th>{t('Actions')}</th>
                </tr>
                </thead>

                <tbody>
                {data && data.data ? (
                    data.data.map((grp) => (
                        <tr key={grp._id}>
                            <td>{moment(grp.createdAt).format('lll')}</td>
                            <td>{grp.group_name}</td>
                            <td>{grp.description}</td>
                            <td>
                                <div className="btn-group">
                                    <button
                                        className="btn"
                                        onClick={() => editHandler(grp)}
                                        data-bs-toggle="modal"
                                        data-bs-target="#masterGroupModal"
                                    >
                                        <img src={EditItemIcon} alt="Edit" className="icon-img action-icons-img" />
                                    </button>

                                    <button
                                        className="btn"
                                        onClick={() => deleteHandler(grp._id)}
                                        disabled={isLoadingDelete}
                                    >
                                        {isLoadingDelete ? (
                                            <span className="spinner-border spinner-border-sm" />
                                        ) : (
                                            <img src={DeleteItemIcon} alt="Delete" className="icon-img action-icons-img" />
                                        )}
                                    </button>
                                </div>
                            </td>
                        </tr>
                    ))
                ) : (
                    <tr>
                        <td colSpan="4">Error: Failed to fetch group data</td>
                    </tr>
                )}
                </tbody>
            </table>
        </div>
    );
};

export default ViewMasterGroups;
